import React from "react";
import { theme } from "../styles/theme";
import { ModuleType } from "../constants";

export const IconCheck = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
      >
        <g data-name="Group 4048">
          <g
            data-name="Ellipse 1760"
            transform="translate(-330.265 -449.729) rotate(90 -46.732 403.997)"
            fill="#fff"
            stroke="#f5f5f5"
            strokeWidth={1}
          >
            <circle cx={13} cy={13} r={13} stroke="none" />
            <circle cx={13} cy={13} r={13.5} fill="none" />
          </g>
          <g
            data-name="Group 4047"
            fill="#73d373"
            stroke="#5d535c"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path
              data-name="Path 1348"
              d="M11.708 0L4.019 9.163"
              strokeWidth={3}
              transform="translate(-330.265 -449.729) translate(338.411 458.85)"
            />
            <path
              data-name="Path 1349"
              d="M0 5.879l3.976 3.337"
              strokeWidth={3.0003}
              transform="translate(-330.265 -449.729) translate(338.411 458.85)"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export const IconBack = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 39.193 39.193"
    >
      <g
        id="Group_2160"
        data-name="Group 2160"
        transform="translate(331.046 701.69) rotate(180)"
      >
        <g
          id="Group_2022"
          data-name="Group 2022"
          transform="translate(291.854 662.497)"
        >
          <circle
            id="Ellipse_79"
            data-name="Ellipse 79"
            cx="19.596"
            cy="19.596"
            r="19.596"
            fill={theme.col_2}
          />
        </g>
        <path
          id="Path_1331"
          data-name="Path 1331"
          d="M6.746,13.492,0,6.746,6.746,0"
          transform="translate(315.51 689.145) rotate(180)"
          fill="none"
          stroke="#FFF"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="4"
        />
      </g>
    </svg>
  );
};

export const IconProfile = ({ activeTab }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-jpg73"
      focusable="false"
      viewBox="0 0 24 24"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>user_outlined</title>
      <path
        fill={activeTab === 0 ? theme.col_2 : theme.col_6}
        d="M12,12A4,4,0,1,0,8,8,4,4,0,0,0,12,12Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,12,6Zm7.89,12.55L18,14.66A3,3,0,0,0,15.26,13H8.74a3,3,0,0,0-2.69,1.66L4.11,18.55A1,1,0,0,0,5,20H19A1,1,0,0,0,19.89,18.55ZM6.62,18l1.22-2.45a1,1,0,0,1,.9-.55h6.52a1,1,0,0,1,.9.55L17.38,18Z"
      ></path>
    </svg>
  );
};

export const IconPerson = (props) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-1k33q06"
      focusable="false"
      viewBox="0 0 30 30"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M16.3359 3.60254H15.7383V3.00488C15.7383 2.63812 15.441 2.34082 15.0742 2.34082C14.7075 2.34082 14.4102 2.63812 14.4102 3.00488V3.60254H13.8125C13.4457 3.60254 13.1484 3.89984 13.1484 4.2666C13.1484 4.63336 13.4457 4.93066 13.8125 4.93066H14.4102V5.52832C14.4102 5.89508 14.7075 6.19238 15.0742 6.19238C15.441 6.19238 15.7383 5.89508 15.7383 5.52832V4.93066H16.3359C16.7027 4.93066 17 4.63336 17 4.2666C17 3.89984 16.7027 3.60254 16.3359 3.60254Z"
        fill="white"
      ></path>
      <path
        d="M10.4726 7.64439C11.4834 6.86345 12.1357 5.63988 12.1357 4.2666C12.1357 1.91399 10.2217 0 7.86914 0C5.51653 0 3.60254 1.91399 3.60254 4.2666C3.60254 5.63985 4.25485 6.86345 5.26572 7.64439C2.26754 8.69235 0 11.5689 0 15.0742C0 15.441 0.297301 15.7383 0.664062 15.7383H15.0742C15.441 15.7383 15.7383 15.441 15.7383 15.0742C15.7383 11.568 13.469 8.69175 10.4726 7.64439ZM4.93066 4.2666C4.93066 2.64632 6.24886 1.32812 7.86914 1.32812C9.48942 1.32812 10.8076 2.64632 10.8076 4.2666C10.8076 5.88688 9.48942 7.20508 7.86914 7.20508C6.24886 7.20508 4.93066 5.88688 4.93066 4.2666ZM1.36159 14.4102C1.69538 11.1141 4.48651 8.5332 7.86914 8.5332C11.2518 8.5332 14.0429 11.1141 14.3767 14.4102H1.36159Z"
        fill="white"
      ></path>
    </svg>
  );
};

export const IconPersonTotal = () => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall css-1k33q06"
      focusable="false"
      viewBox="0 0 16 16"
      aria-hidden="true"
    >
      <path
        d="M10.4726 7.64439C11.4834 6.86345 12.1357 5.63988 12.1357 4.2666C12.1357 1.91399 10.2217 0 7.86914 0C5.51653 0 3.60254 1.91399 3.60254 4.2666C3.60254 5.63985 4.25485 6.86345 5.26572 7.64439C2.26754 8.69235 0 11.5689 0 15.0742C0 15.441 0.297301 15.7383 0.664062 15.7383H15.0742C15.441 15.7383 15.7383 15.441 15.7383 15.0742C15.7383 11.568 13.469 8.69175 10.4726 7.64439ZM4.93066 4.2666C4.93066 2.64632 6.24886 1.32812 7.86914 1.32812C9.48942 1.32812 10.8076 2.64632 10.8076 4.2666C10.8076 5.88688 9.48942 7.20508 7.86914 7.20508C6.24886 7.20508 4.93066 5.88688 4.93066 4.2666ZM1.36159 14.4102C1.69538 11.1141 4.48651 8.5332 7.86914 8.5332C11.2518 8.5332 14.0429 11.1141 14.3767 14.4102H1.36159Z"
        fill="currentColor"
      ></path>
      <path d="M15 1V5H13.7927V1.87429H13V1H15Z" fill="currentColor"></path>
    </svg>
  );
};

export function LicenseIcon({ activeTab, fontSize }) {
  return (
    <svg viewBox="0 0 30 34" width={fontSize - 4 || 40} height={fontSize - 8 || 30} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32 6.5H4C3.46957 6.5 2.96086 6.71071 2.58579 7.08579C2.21071 7.46086 2 7.96957 2 8.5V28.5C2 29.0304 2.21071 29.5391 2.58579 29.9142C2.96086 30.2893 3.46957 30.5 4 30.5H19L19.57 29.8L20.5 28.66L20.41 28.5H4V8.5H32V17.06C32.7597 17.5518 33.4351 18.163 34 18.87V8.5C34 7.96957 33.7893 7.46086 33.4142 7.08579C33.0391 6.71071 32.5304 6.5 32 6.5Z"
        fill={activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4}
      />
      <path
        d="M7 12.5H24V14.1H7V12.5Z"
        fill={activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4}
      />
      <path
        d="M7 16.5H18V18.1H7V16.5Z"
        fill={activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4}
      />
      <path
        d="M7 23.5H17V25.1H7V23.5Z"
        fill={activeTab === ModuleType?.licence ? theme.col_2 : theme.col_4}
      />
      <path
        d="M27.4598 17.73C26.1802 17.7198 24.9272 18.0959 23.8647 18.8092C22.8021 19.5224 21.9795 20.5396 21.5042 21.7278C21.0289 22.9159 20.9232 24.2199 21.2007 25.4691C21.4782 26.7184 22.1262 27.8548 23.0598 28.73L21.1198 31.1L22.0198 34.71L25.6798 30.25C26.8384 30.5926 28.0713 30.5926 29.2298 30.25L32.8898 34.71L33.7898 31.1L31.8498 28.73C32.7835 27.8548 33.4314 26.7184 33.709 25.4691C33.9865 24.2199 33.8807 22.9159 33.4054 21.7278C32.9302 20.5396 32.1075 19.5224 31.045 18.8092C29.9825 18.0959 28.7295 17.7198 27.4498 17.73H27.4598ZM27.4598 28.41C26.61 28.3982 25.7827 28.1354 25.0819 27.6546C24.381 27.1739 23.838 26.4967 23.5209 25.7082C23.2039 24.9197 23.1271 24.055 23.3001 23.223C23.4731 22.3909 23.8882 21.6286 24.4933 21.0318C25.0984 20.435 25.8664 20.0304 26.7008 19.8689C27.5352 19.7075 28.3987 19.7962 29.1827 20.1241C29.9668 20.452 30.6364 21.0044 31.1074 21.7118C31.5784 22.4193 31.8297 23.2501 31.8298 24.1C31.8193 25.2502 31.3535 26.3494 30.5346 27.1571C29.7156 27.9649 28.6101 28.4153 27.4598 28.41Z"
        fill={activeTab === ModuleType?.licence ?  theme.col_2 : theme.col_4}
      />
    </svg>
  );
}


export function LicenseIconAdmin({ activeTab, fontSize }) {
  return (
    <svg viewBox="0 0 30 34" width={70} height={50} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32 6.5H4C3.46957 6.5 2.96086 6.71071 2.58579 7.08579C2.21071 7.46086 2 7.96957 2 8.5V28.5C2 29.0304 2.21071 29.5391 2.58579 29.9142C2.96086 30.2893 3.46957 30.5 4 30.5H19L19.57 29.8L20.5 28.66L20.41 28.5H4V8.5H32V17.06C32.7597 17.5518 33.4351 18.163 34 18.87V8.5C34 7.96957 33.7893 7.46086 33.4142 7.08579C33.0391 6.71071 32.5304 6.5 32 6.5Z"
        fill={theme.col_3}
      />
      <path
        d="M7 12.5H24V14.1H7V12.5Z"
        fill={theme.col_3}
      />
      <path
        d="M7 16.5H18V18.1H7V16.5Z"
        fill={theme.col_3}
      />
      <path
        d="M7 23.5H17V25.1H7V23.5Z"
        fill={theme.col_3}
      />
      <path
        d="M27.4598 17.73C26.1802 17.7198 24.9272 18.0959 23.8647 18.8092C22.8021 19.5224 21.9795 20.5396 21.5042 21.7278C21.0289 22.9159 20.9232 24.2199 21.2007 25.4691C21.4782 26.7184 22.1262 27.8548 23.0598 28.73L21.1198 31.1L22.0198 34.71L25.6798 30.25C26.8384 30.5926 28.0713 30.5926 29.2298 30.25L32.8898 34.71L33.7898 31.1L31.8498 28.73C32.7835 27.8548 33.4314 26.7184 33.709 25.4691C33.9865 24.2199 33.8807 22.9159 33.4054 21.7278C32.9302 20.5396 32.1075 19.5224 31.045 18.8092C29.9825 18.0959 28.7295 17.7198 27.4498 17.73H27.4598ZM27.4598 28.41C26.61 28.3982 25.7827 28.1354 25.0819 27.6546C24.381 27.1739 23.838 26.4967 23.5209 25.7082C23.2039 24.9197 23.1271 24.055 23.3001 23.223C23.4731 22.3909 23.8882 21.6286 24.4933 21.0318C25.0984 20.435 25.8664 20.0304 26.7008 19.8689C27.5352 19.7075 28.3987 19.7962 29.1827 20.1241C29.9668 20.452 30.6364 21.0044 31.1074 21.7118C31.5784 22.4193 31.8297 23.2501 31.8298 24.1C31.8193 25.2502 31.3535 26.3494 30.5346 27.1571C29.7156 27.9649 28.6101 28.4153 27.4598 28.41Z"
        fill={theme.col_3}
      />
    </svg>
  );
}


export function LicenceTickIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30px"
      height="auto"
      viewBox="0 0 107.492 97.166"
      {...props}
    >
      <g
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeWidth="20"
        data-name="Group 1"
        transform="translate(-459.444 -2151.91)"
      >
        <path
          d="M0 0L21.739 27.174"
          data-name="Line 1"
          transform="translate(473.5 2207.847)"
        ></path>
        <path
          d="M0 68.477L57.608 0"
          data-name="Line 2"
          transform="translate(495.239 2166)"
        ></path>
      </g>
    </svg>
  );
}
